import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-user-settings', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: 'auto',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('.tb-user-settings table', {
    borderSpacing: 0,
});

cssRule('.tb-user-settings table.tb-root-table', {
    marginTop: '18px',
});

cssRule('.tb-user-settings table tbody tr', {
    verticalAlign: 'top',
});

cssRule('.tb-user-settings table tbody tr td, .tb-user-settings table tbody tr .tb-label-multiline', {
    paddingTop: '3px',
    paddingBottom: '3px',
    paddingLeft: '12px',
    paddingRight: '12px',
    height: '23px',
});

cssRule('.tb-user-settings table tbody tr td.tb-nested-table, .tb-user-settings table tbody tr .tb-label-multiline.tb-nested-table', {
    padding: 0,
});

cssRule('.tb-user-settings table tbody tr.tb-divider > td', {
    padding: 0,
    height: 0,
});

cssRule('.tb-user-settings table tbody tr.tb-divider > td .tb-line', {
    marginTop: '12px',
    marginBottom: '12px',
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.active, '#e6e6e6'),
    height: '1px',
});

cssRule('.tb-user-settings table .tb-label', {
    paddingLeft: '18px',
    textAlign: 'right',
    fontSize: '15px',
    fontWeight: 'normal',
    color: applyColor(DesignTokens.color.font.default.subtle, '#999'),
    verticalAlign: 'top',
    minWidth: '242px',
});

cssRule('.tb-user-settings table .tb-details-value', {
    width: '500px',
    fontSize: '12px',
    maxWidth: '500px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-user-settings table .tb-details-value-multi-line', {
    width: '500px',
    fontSize: '12px',
    maxWidth: '500px',
    whiteSpace: 'normal',
});

cssRule('.tb-user-settings table .tb-details-button-cell .tb-outline-button', {
    minWidth: '156px',
    float: 'right',
    textAlign: 'center',
    marginTop: '6px',
});

cssRule('.tb-user-settings table .tb-details-button-cell .tb-outline-button:first-child', {
    marginTop: 0,
});

cssRule('.tb-user-settings table .tb-popup-menu-button', {
    minWidth: '250px',
});

cssRule('.tb-oauth-table .tb-credential-type-header', {
    padding: '5px',
});

cssRule('.tb-oauth-table .tb-credential-type-header .tb-credential-type-title', {
    fontWeight: 'bold',
    display: 'inline-block',
    width: '250px',
    marginLeft: '3px',
});

cssRule('.tb-oauth-table .tb-credential-type-header .tb-oauth-idp-title', {
    fontWeight: 'bold',
    display: 'inline-block',
    width: '200px',
    marginLeft: '6px',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.dark, '#dadada'),
});

cssRule('.tb-oauth-table .tb-oauth-type-header', {
    padding: '5px',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.dark, '#dadada'),
});

cssRule('.tb-oauth-table .tb-oauth-type-header .tb-oauth-type-title', {
    fontWeight: 'bold',
    display: 'inline-block',
    width: '250px',
});

cssRule('.tb-oauth-table .tb-oauth-type-header .tb-oauth-type-add', {
    fontSize: '12px',
});

cssRule('.tb-oauth-table .tb-oauth-type-row', {
    margin: '3px 6px 3px 12px',
});

cssRule('.tb-oauth-table .tb-oauth-type-row .tb-oauth-type-row-details, .tb-oauth-table .tb-oauth-type-row .tb-oauth-test-results', {
    display: 'inline-block',
    verticalAlign: 'top',
});

cssRule('.tb-oauth-table .tb-oauth-type-row .tb-oauth-type-username', {
    width: '300px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-oauth-table .tb-oauth-type-row .tb-oauth-type-username, .tb-oauth-table .tb-oauth-type-row .tb-oauth-type-delete, .tb-oauth-table .tb-oauth-type-row .tb-oauth-type-test', {
    display: 'inline-block',
    marginRight: '12px',
    verticalAlign: 'middle',
});

cssRule('.tb-oauth-table .tb-oauth-type-row .tb-oauth-test-message', {
    display: 'inline-block',
    width: '300px',
    whiteSpace: 'normal',
});

cssRule('.tb-edit-language-and-locale .tb-select', {
    display: 'inline-block',
    verticalAlign: 'top',
});

cssRule('.tb-edit-time-zone .tb-select', {
    display: 'inline-block',
    verticalAlign: 'top',
});

cssRule('.tb-user-settings-connected-device-info-icon', {
    display: 'inline-block',
    verticalAlign: 'top',
    marginTop: '5px',
    marginLeft: '6px',
    width: '17px',
    height: '17px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/info_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-user-settings-connected-device-info-icon:hover', {
    backgroundImage: 'url(img/info_hover.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-user-settings-item-table', {
    fontSize: '12px',
    verticalAlign: 'top',
});

cssRule('.tb-user-settings-item-table table', {
    borderSpacing: 0,
});

cssRule('.tb-user-settings-item-table table > tbody > tr', {
    verticalAlign: 'middle',
});

cssRule('.tb-user-settings-item-table table > tbody > tr > td', {
    padding: 0,
});

cssRule('.tb-user-settings-item-table table > tbody > tr .tb-user-settings-item-name', {
    maxWidth: '254px',
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

